module.exports = __webpack_public_path__ + "static/founded-4067af3876709ca6a630cef3d505f726.png";